module.exports = __webpack_public_path__ + "img/fxWalletConnect@2x.837a8a7a.jpg";